import React from "react";
import {
  HStack,
  IconButton,
  Select,
  Text,
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const DEFAULT_OPTIONS = [25, 50, 100, 250, 500];

const TradePagination = ({
  numResults,
  startOffset,
  endOffset,
  totalCount,
  canGoPrev,
  canGoNext,
  onBackPage,
  onNextPage,
  onNumResultsChange,
  options = DEFAULT_OPTIONS,
}) => {
  return (
    <HStack spacing={1} mt={-1} justifyContent="flex-end" flexWrap="wrap">
      <HStack spacing={1}>
        <Text fontSize="xs" fontWeight="semibold">Rows:</Text>
        <Select
          maxW={70}
          variant="filled"
          size="xs"
          value={numResults}
          onChange={onNumResultsChange}
        >
          {options.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </Select>
      </HStack>
      <HStack spacing={0}>
        <IconButton
          aria-label="Previous page"
          icon={<ChevronLeftIcon />}
          size="xs"
          minW="20px"
          h="20px"
          variant="ghost"
          borderRadius="full"
          isDisabled={!canGoPrev}
          onClick={onBackPage}
        />
        <IconButton
          aria-label="Next page"
          icon={<ChevronRightIcon />}
          size="xs"
          minW="20px"
          h="20px"
          variant="ghost"
          borderRadius="full"
          isDisabled={!canGoNext}
          onClick={onNextPage}
        />
        <Text fontSize="xs" fontWeight="semibold">
          {startOffset}-{endOffset} of {totalCount}
        </Text>
      </HStack>
    </HStack>
  );
};

export default TradePagination;
